module.exports = __webpack_public_path__ + "img/Reunião em comunidades produtoras de macieira 3.eba54c45.webp";